<template>
<div>
    <div class="row" v-if="!ready">
        <div class="col">
            <sau-loading></sau-loading>
        </div>
    </div>
    <div class="row pt-12" v-else>
        <div class="col-lg-3">
            <img src="/img/apiro-full-180.gif" />
        </div>
        <div class="col-lg-5">
            <h2 class="pt-12">Payment Complete</h2>
            <p>Your payment of <span class="sau-font-bold">${{ invoiceComplete.total }}</span> has been successfully processed.</p>
            <p>Thank You.</p>
            <a href="/billing/invoices" class="btn btn-success">View Invoices</a>
        </div>
        <div class="col-lg-4 pt-4">
            <div class="sau-bx-shadow p-6">
                <div class="text-center px-4">
                    <h4 class="text-center sau-pm-reset">Invoice</h4>
                    <img src="/img/illustrations/invoice-paid.gif" alt="Invoice"/>
                    <p class="sau-pm-reset pb-2">Invoice Number: {{ invoiceComplete.id }}</p>
                    <a :href="`/billing/invoices/${invoiceComplete.id}`" class="sau-link-button sm d-block py-2">View Invoice</a>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>

export default {
    props: ['invoice-complete'],
    data(){
        return{
            ready: false,
        }
    },
    created() {
        this.ready = true;
    },
    methods:{
    }
}
</script>
